import { useSearchParams } from 'react-router-dom'

export const usePageId = (): string | undefined => {
  const [searchParams] = useSearchParams()

  return searchParams.get('pageId') ?? undefined
}
